/*
* Aydin Cinar <cinar.aydinn@gmail.com>
* Actions
*/

export const ADD_OR_UPDATE_ANSWERS = 'add-or-update-answers';
export const CLEAR_ANSWERS = 'clear-answers';
export const FETCH_SERVICES = 'fetch-services';
export const FETCH_QUESTIONS = 'fetch-questions';
export const UPDATE_PROGRESS = 'update-progress';